import type { CloudConnectSubscription } from 'src/api/endpoints/cloudConnect.types';
import { useCloudConnectPaymentHistory } from 'src/api/queries';
import { CloudConnectBillingInfoDetails } from 'src/apps/manageSubscription/app/components/CloudConnectBillingInfoDetails';
import {
  CloudConnectNextBillingCard,
  CloudConnectNoBillingDetails,
} from 'src/apps/manageSubscription/app/components/CloudConnectNextBillingCard';
import { CloudConnectPaymentHistoryCard } from 'src/apps/manageSubscription/app/components/CloudConnectPaymentHistoryCard';
import { CloudConnectPaymentIntervalCard } from 'src/apps/manageSubscription/app/components/CloudConnectPaymentIntervalCard';
import { CloudConnectPaymentMethodDetails } from 'src/apps/manageSubscription/app/components/CloudConnectPaymentMethodDetails';
import { PaymentHistoryFAQ } from 'src/apps/manageSubscription/app/components/PaymentHistoryFAQ';
import { Divider, Sheet } from 'src/components';

export const CloudConnectPaymentPage = ({
  subscription,
}: {
  subscription: CloudConnectSubscription | null;
}) => {
  const paymentHistory = useCloudConnectPaymentHistory();
  const hasPaymentHistory = (paymentHistory.data?.length ?? 0) > 0;

  if (!subscription || subscription.productId === 'connect_legacy') {
    return (
      <div className="flex flex-col gap-24 lm:gap-32">
        <Sheet className="gap-24">
          <CloudConnectNoBillingDetails />
        </Sheet>
        {hasPaymentHistory && <CloudConnectPaymentHistoryCard />}
        <PaymentHistoryFAQ />
      </div>
    );
  }

  const canChangePaymentInterval =
    !subscription.cancelAtPeriodEnd &&
    (subscription.status === 'active' || subscription.status === 'trialing');

  return (
    <div className="flex flex-col gap-24 lm:gap-32">
      <CloudConnectNextBillingCard subscription={subscription} />
      {canChangePaymentInterval && (
        <CloudConnectPaymentIntervalCard subscription={subscription} />
      )}
      <Sheet className="gap-24">
        <CloudConnectPaymentMethodDetails subscription={subscription} />
        <Divider />
        <CloudConnectBillingInfoDetails subscription={subscription} />
      </Sheet>
      <CloudConnectPaymentHistoryCard />
      <PaymentHistoryFAQ />
    </div>
  );
};
